import { render, staticRenderFns } from "./ICUsers.vue?vue&type=template&id=22263dfb&scoped=true"
import script from "./ICUsers.vue?vue&type=script&lang=js"
export * from "./ICUsers.vue?vue&type=script&lang=js"
import style0 from "./ICUsers.vue?vue&type=style&index=0&id=22263dfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22263dfb",
  null
  
)

export default component.exports